import {
    FETCH_API_KEY_SUCCESS,
    FETCH_API_KEY_ERROR
  } from '../actions/api-key'
  
  const initialState = {
    items: null,
    error: null,
    loading: false
  }
  
  export default function (state = initialState, action) {
    switch (action.type) {
      case FETCH_API_KEY_SUCCESS:
        return { ...state, items: (action||{}).data }
      case FETCH_API_KEY_ERROR:
        return { ...state, error: action.message }
      default:
        return state
    }
  }